import * as React from "react";
import { SummaryCard } from "kw/admin/components/SummaryCard";
import { VerticalSpacer } from "kanopi-components/SpaceWrapper/VerticalSpacer";
import { HeadingActionsBar } from "kanopi-components/HeadingActionBar/HeadingActionsBar";
import { Placeholder } from "kanopi-components/Placeholder";
import { useEffect } from "react";
import { useClaims } from "kw/claims/hooks/useClaims";
import { ClaimStatusTypes } from "kw/api/zeus";
import { COLOR } from "baseui/badge";
import { AdminRiskStateSection } from "kw/admin/components/AdminRiskStateSection";

type TClaimDetailsPageProps = {
  claimId: string;
};

export const ClaimDetailsPage = ({ claimId }: TClaimDetailsPageProps) => {
  const { claim, loading, fetchClaim } = useClaims();

  useEffect(() => {
    fetchClaim(claimId);
  }, []);

  const headingCaptionProps = (claim: TClaim) => {
    let color;
    switch (claim?.statusType) {
      case ClaimStatusTypes.OPEN:
        color = COLOR.positive;
        break;
      case ClaimStatusTypes.CLOSED:
        color = COLOR.negative;
        break;
    }
    return { caption: claim?.statusTypeDisplay, captionColor: color };
  };

  return (
    <Placeholder loading={!claim || loading}>
      <VerticalSpacer>
        <HeadingActionsBar
          heading={`Claim ${claimId}`}
          {...headingCaptionProps(claim)}
        />
        <SummaryCard data-testid="claimSummaryArea" title="Details">
          <AdminRiskStateSection
            riskProfile={claim?.claimProfile}
            questionSets={claim?.claimProfile?.riskStateQuestionSets}
          />
        </SummaryCard>
      </VerticalSpacer>
    </Placeholder>
  );
};
